import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';
import { OrgSelect } from '/imports/ui/OrgSelect';
import { NotificationDrawer } from '/imports/ui/NotificationDrawer';

const AppHeaderStyled = styled.div`
  display: flex;
  border-bottom: 1px solid ${css.black};
  min-height: ${css.appHeaderHeight};
  .org-select-wrapper, .breadcrumb-wrapper {
    ${css.flexVerticalCenter}
    margin-left: 0.5rem;
    ${css.mobileMedia} {
      margin-left: 4rem;
      margin-right: 12rem;
    }
  }
  .logo {
    position: absolute;
    top: 0.75rem;
    right: 1rem;
  }
  .notifications-wrapper {
    ${css.flexVerticalCenter}
    margin-left: auto;
    margin-right: 0.5rem;
  }
  &.print-mode {
    display: none;
  }
`;

/** Top application header bar: the org selector on the left, the notification bell on the right. */
export const AppHeader = () => {
  return (
    <AppHeaderStyled className="app-header">
      <div className="org-select-wrapper"><OrgSelect /></div>
      <div className="notifications-wrapper"><NotificationDrawer /></div>
    </AppHeaderStyled>
  );
};
